"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Attachment = void 0;
/**
 * For referring to data content defined in other formats.
 */
var Attachment = /** @class */ (function () {
    function Attachment() {
    }
    return Attachment;
}());
exports.Attachment = Attachment;
